import { LOCAL_STORAGE, SESSION_STORAGE } from '@core/providers/web-storage.providers';
import { AccessTokenLSRepository } from '@core/repositories/access-token-ls-repository.service';
import { AuthApiService } from '@core/services/auth.api.service';
import { WebStorage } from '@core/storages/web-storage/web-storage';
import { UserOperationalSystemService } from './services/user-operational-system.service';
import { RouteDataService } from './services/route-data.service';
import { SnackBarService } from './services/snackbar.service';
import { ClientPortalApiService } from './api/client-portal-api.service';
import { AccountService } from './services/account.service';
import { ClipboardService } from './services/clipboard.service';

export const CORE_SERVICES = [
  ClientPortalApiService,
  ClipboardService,
  AccessTokenLSRepository,
  SnackBarService,
  AccountService,
  RouteDataService,
  UserOperationalSystemService,
  AuthApiService,
  {
    provide: LOCAL_STORAGE,
    useFactory: () => new WebStorage(window.localStorage),
  },
  {
    provide: SESSION_STORAGE,
    useFactory: () => new WebStorage(window.sessionStorage),
  },
];
